// Soft, rotating tint palette for kiosk tile grids (locations / groups / names).
// Built from theme chart tokens (arbitrary-value classes) so both Morning Light
// and Aurora Night stay in gamut — do NOT swap back to literal Tailwind shades.
const TILE_TONES = [
  'bg-[hsl(var(--chart-6)/0.1)] border-[hsl(var(--chart-6)/0.3)] hover:bg-[hsl(var(--chart-6)/0.15)]',
  'bg-[hsl(var(--warning)/0.1)] border-[hsl(var(--warning)/0.3)] hover:bg-[hsl(var(--warning)/0.15)]',
  'bg-[hsl(var(--success)/0.1)] border-[hsl(var(--success)/0.3)] hover:bg-[hsl(var(--success)/0.15)]',
  'bg-[hsl(var(--chart-2)/0.1)] border-[hsl(var(--chart-2)/0.3)] hover:bg-[hsl(var(--chart-2)/0.15)]',
  'bg-[hsl(var(--chart-5)/0.1)] border-[hsl(var(--chart-5)/0.3)] hover:bg-[hsl(var(--chart-5)/0.15)]',
  'bg-[hsl(var(--chart-4)/0.1)] border-[hsl(var(--chart-4)/0.3)] hover:bg-[hsl(var(--chart-4)/0.15)]',
  'bg-[hsl(var(--chart-3)/0.1)] border-[hsl(var(--chart-3)/0.3)] hover:bg-[hsl(var(--chart-3)/0.15)]',
  'bg-[hsl(var(--primary)/0.1)] border-[hsl(var(--primary)/0.3)] hover:bg-[hsl(var(--primary)/0.15)]',
] as const;

/** Soft tile tint that cycles by index. */
export const tileTone = (index: number): string => TILE_TONES[index % TILE_TONES.length];

/** Touch/press + focus feedback for the raw-button tiles (so a tap visibly responds). */
export const TILE_INTERACTIVE =
  'cursor-pointer transition active:scale-[0.97] focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2';

/** Split a full name into a big first name + the rest (second line). */
export function splitName(full: string): { first: string; rest: string } {
  const parts = full.trim().split(/\s+/);
  return { first: parts[0] ?? full, rest: parts.slice(1).join(' ') };
}
